<formly-field *ngFor="let field of field.fieldGroup"
  [field]="field">
</formly-field>